"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var dialog_component_1 = require("./dialog.component");
var DateTimePickerDirective = (function () {
    function DateTimePickerDirective(vcRef, componentFactoryResolver, el) {
        this.vcRef = vcRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.el = el;
        this.dateTimePickerChange = new core_1.EventEmitter(true);
        this.dateTimePickerError = new core_1.EventEmitter(true);
        this.autoClose = false;
        this.locale = 'en';
        this.viewFormat = 'll';
        this.returnObject = 'js';
        this.mode = 'popup';
        this.hourTime = '24';
        this.theme = '#0070ba';
        this.minMoment = null;
        this.maxMoment = null;
        this.position = 'bottom';
        this.positionOffset = '0%';
        this.pickerType = 'both';
        this.showSeconds = false;
        this.onlyCurrentMonth = false;
        this.created = false;
    }
    DateTimePickerDirective.prototype.ngOnChanges = function (changes) {
        if (this.mode === 'inline' &&
            changes['dateTimePicker'] &&
            !changes['dateTimePicker'].isFirstChange()) {
            this.dialog.setSelectedMoment(this.dateTimePicker);
        }
    };
    DateTimePickerDirective.prototype.ngOnInit = function () {
        if (this.mode === 'inline') {
            this.openDialog();
        }
    };
    DateTimePickerDirective.prototype.onClick = function () {
        this.openDialog();
    };
    DateTimePickerDirective.prototype.momentChanged = function (value) {
        this.dateTimePickerChange.emit(value);
    };
    DateTimePickerDirective.prototype.sendError = function (error) {
        this.dateTimePickerError.emit(error);
        return;
    };
    DateTimePickerDirective.prototype.openDialog = function () {
        if (!this.created) {
            this.created = true;
            var factory = this.componentFactoryResolver.resolveComponentFactory(dialog_component_1.DialogComponent);
            var injector = core_1.ReflectiveInjector.fromResolvedProviders([], this.vcRef.parentInjector);
            var cmpRef = this.vcRef.createComponent(factory, 0, injector, []);
            cmpRef.instance.setDialog(this, this.el, this.dateTimePicker, this.autoClose, this.locale, this.viewFormat, this.returnObject, this.position, this.positionOffset, this.mode, this.hourTime, this.theme, this.pickerType, this.showSeconds, this.onlyCurrentMonth, this.minMoment, this.maxMoment);
            this.dialog = cmpRef.instance;
        }
        else if (this.dialog) {
            this.dialog.openDialog(this.dateTimePicker);
        }
    };
    return DateTimePickerDirective;
}());
DateTimePickerDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[dateTimePicker]',
                host: {
                    '(click)': 'onClick()',
                }
            },] },
];
DateTimePickerDirective.ctorParameters = function () { return [
    { type: core_1.ViewContainerRef, },
    { type: core_1.ComponentFactoryResolver, },
    { type: core_1.ElementRef, },
]; };
DateTimePickerDirective.propDecorators = {
    'dateTimePicker': [{ type: core_1.Input, args: ['dateTimePicker',] },],
    'dateTimePickerChange': [{ type: core_1.Output, args: ['dateTimePickerChange',] },],
    'dateTimePickerError': [{ type: core_1.Output, args: ['dateTimePickerError',] },],
    'autoClose': [{ type: core_1.Input },],
    'locale': [{ type: core_1.Input },],
    'viewFormat': [{ type: core_1.Input },],
    'returnObject': [{ type: core_1.Input },],
    'mode': [{ type: core_1.Input },],
    'hourTime': [{ type: core_1.Input },],
    'theme': [{ type: core_1.Input },],
    'minMoment': [{ type: core_1.Input },],
    'maxMoment': [{ type: core_1.Input },],
    'position': [{ type: core_1.Input },],
    'positionOffset': [{ type: core_1.Input },],
    'pickerType': [{ type: core_1.Input },],
    'showSeconds': [{ type: core_1.Input },],
    'onlyCurrentMonth': [{ type: core_1.Input },],
};
exports.DateTimePickerDirective = DateTimePickerDirective;
//# sourceMappingURL=picker.directive.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/picker.directive.js
// module id = ../../../../ng-pick-datetime/picker.directive.js
// module chunks = 18